import axiosInstance from '@src/utils/axios';

import DefaultAPIHandler from './DefaultAPIHandler';

const ai = axiosInstance();

export const post = async (payload: { testType: string; symptomDate: string }): Promise<string> => {
  try {
    const { data } = await ai.post(`/verification`, payload);
    return data;
  } catch (error) {
    throw DefaultAPIHandler(error, 'Could not update information');
  }
};
